(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var so = document.getElementById('pg-so');
  if (!so) return;
  var input = so.querySelector('[data-so-input]');
  var res = so.querySelector('[data-so-res]');
  var hint = res.innerHTML;
  var timer = null;
  var last = '';
  var lastFocus = null;

  function money(cents) {
    var n = cents / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function open() {
    lastFocus = document.activeElement;
    so.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 30);
  }

  function close() {
    so.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function group(title, shape, items) {
    if (!items.length) return '';
    var h = '<div class="grp"><b><i class="pg-shape pg-shape--' + shape + '" aria-hidden="true"></i>' + title + '</b>';
    items.forEach(function (it) { h += it; });
    return h + '</div>';
  }

  function render(q, data) {
    var r = data.resources.results;
    var products = (r.products || []).slice(0, 5).map(function (p) {
      var sale = p.compare_at_price_max && Number(p.compare_at_price_max) > Number(p.price);
      var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '&width=160" alt="">' : '<span style="width:52px;height:40px;border-radius:9px;background:var(--pg-alt);flex:0 0 auto"></span>';
      return '<a class="r" href="' + esc(p.url) + '">' + img + '<span><span class="t">' + esc(p.title.replace('SAMPLE: ', '')) + '</span><span class="m">' + esc(p.type || '') + '</span></span><span class="pr' + (sale ? ' s' : '') + '">' + money(Number(p.price) * 100) + '</span></a>';
    });
    var articles = (r.articles || []).slice(0, 3).map(function (a) {
      return '<a class="r" href="' + esc(a.url) + '"><span><span class="t">' + esc(a.title) + '</span><span class="m">Blog post</span></span></a>';
    });
    var pages = (r.pages || []).slice(0, 3).map(function (p) {
      return '<a class="r" href="' + esc(p.url) + '"><span><span class="t">' + esc(p.title) + '</span><span class="m">Page</span></span></a>';
    });
    var collections = (r.collections || []).slice(0, 3).map(function (c) {
      return '<a class="r" href="' + esc(c.url) + '"><span><span class="t">' + esc(c.title) + '</span><span class="m">Collection</span></span></a>';
    });
    var html = group('Products', 1, products) + group('Collections', 2, collections) + group('Blog', 3, articles) + group('Pages', 4, pages);
    if (!html) html = '<div class="none">Nothing matched yet. Keep typing, or try a shorter word.</div>';
    html += '<a class="all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for &ldquo;' + esc(q) + '&rdquo; &rarr;</a>';
    res.innerHTML = html;
  }

  function fetchNow(q) {
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (input.value.trim() === q) render(q, data); })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { res.innerHTML = hint; last = ''; return; }
    if (q === last) return;
    last = q;
    timer = setTimeout(function () { fetchNow(q); }, 180);
  });

  input.addEventListener('keydown', function (e) {
    var rows = res.querySelectorAll('.r, .all');
    if (!rows.length) return;
    var i = Array.prototype.findIndex.call(rows, function (r) { return r.classList.contains('is-hot'); });
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (i >= 0) rows[i].classList.remove('is-hot');
      i = e.key === 'ArrowDown' ? (i + 1) % rows.length : (i - 1 + rows.length) % rows.length;
      rows[i].classList.add('is-hot');
      rows[i].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && i >= 0) {
      e.preventDefault();
      window.location.href = rows[i].getAttribute('href');
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-pg-search-open]') : null;
    if (t) { e.preventDefault(); open(); return; }
    if (e.target.closest && e.target.closest('[data-so-close]')) { close(); return; }
    if (e.target === so) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && so.classList.contains('is-open')) close();
    if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !so.classList.contains('is-open')) {
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
      e.preventDefault();
      open();
    }
  });
})();
